module.exports = __webpack_public_path__ + "img/slide1.a2527639.jpg";